import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { ClientSideValidator, EntityValidationsService } from "../../../../../client-validation-system/validations-service";
import { ValidationActivation, ValidationTypeEnum } from "../../../../../client-validation-system/validations.models";
import { Subscription } from "aurelia-event-aggregator";

@autoinject()
@transient()
export class CancelWorkflowDialog {

    public comment: string;
    public invalidate: boolean;

    validator: ClientSideValidator;
    saveFunc: any;
    cancelFunc: any;
    subscriptionToDocumentClickEvent: Subscription;

    public constructor(private dialogClientService: DialogClientService, 
        private entityValidationsService: EntityValidationsService)  {        
    }

    public cancel() {
        this.cancelFunc();
        this.dialogClientService.hide();
    }

    public save() {
        return new Promise<void>((resolve) => {
            this.validator.validate().then(x => {
                if (x.valid) {
                    this.saveFunc(this.comment);                    
                    this.dialogClientService.hide();
                } else {
                    resolve();
                }
            });
        });
    }

    activate(model: { saveFunc: () => void , cancelFunc: () => void, invalidate: boolean}) {
        this.saveFunc = model.saveFunc;
        this.cancelFunc = model.cancelFunc;
        this.invalidate = model.invalidate;
    }

    attached() {
        const rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "Workflow",
            isCollection: false,
            nestedRulesHolder: [],
            rules: [{
                errorMessage: "Comment is required",
                parameters: null, property: "comment",
                validationType: ValidationTypeEnum.Required
            }]
        };

        this.validator = this.entityValidationsService.getValidator(this, rulesHolder);

        this.subscriptionToDocumentClickEvent = this.cancelFunc();
    }

    detached() {
        this.subscriptionToDocumentClickEvent?.dispose();
    }
}